export class brcInfoReq{
    collectionId:number
    constructor(collectionId:number){
        this.collectionId = collectionId
    }
}
export class ScriptGenReq{
    brcInfo:brcInfoReq[]
    createdUser : string;
    liscenceNo: string
    liscenceDate: Date|string
    constructor(
        brcInfo:brcInfoReq[],
        createdUser : string,
        liscenceNo: string,
        liscenceDate: Date|string
    ){
   this.brcInfo = brcInfo
   this.createdUser = createdUser
   this.liscenceDate = liscenceDate
   this.liscenceNo = liscenceNo
 }
 }
 export class liscenceInfoReq{
    liscenceNo:string
    constructor(liscenceNo:string){
        this.liscenceNo = liscenceNo
    }
}
 export class SaleReq{
    liscenceInfo:liscenceInfoReq[]
    createdUser : string;
    invoiceNo: string
    invoiceDate: Date|string
    saleAmount:number
    finalSaleAmount:number
    discountRate:number
    customer:string
    constructor(
        liscenceInfo:liscenceInfoReq[],
        createdUser : string,
        invoiceNo: string,
    invoiceDate: Date|string,
    saleAmount:number,
    finalSaleAmount:number,
    discountRate:number,
    customer:string

    ){
   this.liscenceInfo = liscenceInfo
   this.createdUser = createdUser
   this.invoiceDate = invoiceDate
   this.invoiceNo = invoiceNo
   this.saleAmount = saleAmount
   this.finalSaleAmount = finalSaleAmount
   this.discountRate = discountRate
        this.customer = customer
 }
 }